export default __webpack_public_path__ + "static/media/menu_icon_h.d2cf1072.svg";